/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Surface_JobsInputs */

const en_marketing_surface_jobs = /** @type {(inputs: Marketing_Surface_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobs`)
};

const es_marketing_surface_jobs = /** @type {(inputs: Marketing_Surface_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajos`)
};

const fr_marketing_surface_jobs = /** @type {(inputs: Marketing_Surface_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tâches`)
};

/**
* | output |
* | --- |
* | "Jobs" |
*
* @param {Marketing_Surface_JobsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_surface_jobs = /** @type {((inputs?: Marketing_Surface_JobsInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Surface_JobsInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_surface_jobs(inputs)
	if (locale === "es") return es_marketing_surface_jobs(inputs)
	return fr_marketing_surface_jobs(inputs)
});